// extracted by mini-css-extract-plugin
module.exports = {"icon-btn":"IconButton_icon-btn__23A7o","icon":"IconButton_icon__3XwPU","text":"IconButton_text__ZeFpz"};